import React from 'react'
import { Icon } from '@therms/atalaya'
import { MobileMenuLink } from '@src/modules/Layout/shared/MobileMenuLink'
import { DASHBOARD_ROUTES } from '../../constants'
import { MdSpaceDashboard } from 'react-icons/md'

function DashboardMobileMenuLink() {
  return (
    <MobileMenuLink to={DASHBOARD_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={MdSpaceDashboard} />
        <span>Dashboard</span>
      </div>
    </MobileMenuLink>
  )
}

export { DashboardMobileMenuLink }
